module.exports = window["core-js/modules/es.array.splice.js"];